var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9997 29.4283C6.8995 29.4283 0.333008 22.8618 0.333008 14.7616C0.333008 6.66146 6.8995 0.0949707 14.9997 0.0949707C23.0999 0.0949707 29.6663 6.66146 29.6663 14.7616C29.6663 22.8618 23.0999 29.4283 14.9997 29.4283ZM24.8657 21.5945C26.2112 19.6554 26.9997 17.3006 26.9997 14.7616C26.9997 8.13422 21.6271 2.76164 14.9997 2.76164C8.37226 2.76164 2.99967 8.13422 2.99967 14.7616C2.99967 17.3006 3.78818 19.6554 5.13368 21.5945C6.63428 19.6124 10.1605 18.7616 14.9997 18.7616C19.8389 18.7616 23.3651 19.6124 24.8657 21.5945ZM22.9526 23.748C22.5623 22.3448 19.7588 21.4283 14.9997 21.4283C10.2405 21.4283 7.43701 22.3448 7.04677 23.748C9.16407 25.6232 11.9489 26.7616 14.9997 26.7616C18.0504 26.7616 20.8353 25.6232 22.9526 23.748ZM14.9997 18.7616C12.0142 18.7616 9.66634 16.6648 9.66634 12.095C9.66634 9.10265 11.7718 6.76164 14.9997 6.76164C18.2186 6.76164 20.333 9.32374 20.333 12.3616C20.333 16.7345 17.9571 18.7616 14.9997 18.7616ZM12.333 12.095C12.333 15.1206 13.424 16.095 14.9997 16.095C16.5699 16.095 17.6663 15.1595 17.6663 12.3616C17.6663 10.6955 16.6206 9.4283 14.9997 9.4283C13.3113 9.4283 12.333 10.5161 12.333 12.095Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.1fbd8d3ff43b2d3b388a4d751b8c9886.svg";
export { ForwardRef as ReactComponent };